// extracted by mini-css-extract-plugin
export default {"container":"ExpandCell_container__jvLfh","drawer":"ExpandCell_drawer__QJFfd"};